import React, { useState } from "react";
import { Input, Form, Col, Row, Button } from "reactstrap";
import ContentsTable from "./ContentsTable";
import { Link } from "react-router-dom";

// Custom Hooks
import useTableController from "hooks/useTableController";

// Validation
import { SearchFilterSchema } from "model/_base/filters/filter-options.schema";

// API
import { useGetContentsQuery } from "services/contents/api";

const ContentsTab = () => {
  const [contents, setContents] = useState();

  // HOOK CHANGE
  const { formik, searchInput, setSearchInput, handleTableChange } = useTableController({
    initialValues: {},
    validationSchema: SearchFilterSchema,
  });

  // API
  const { data, error, isLoading } = useGetContentsQuery(formik.values);
  React.useEffect(() => {
    if (data) {
      setContents(data);
    }
  }, [data]);

  // ACTIONS
  const handleStatusChange = (id, value) => {
    if (!contents) return;

    const updatedItems = contents.data.map((item) => (item.id === id ? { ...item, isHighlight: value } : item));

    setContents((prev) => ({
      ...prev,
      data: updatedItems,
    }));
  };

  // RENDER
  return (
    <Form
      className="form-horizontal w-100 d-flex flex-column gap-4"
      onSubmit={(e) => {
        e.preventDefault();
        formik.handleSubmit();
      }}
      data-testid="search-form"
    >
      <div className="contents-tab" data-testid="tab-contents">
        <div className="header mt-4">
          <h2 className="fw-semibold">รายการโปรโมชัน</h2>
          <div className="d-flex flex-column gap-2">
            <Row className="gy-3">
              <Col sm={12} md={12} lg={10} xl={8}>
                <div className="d-flex gap-3">
                  <div className="flex-grow-1">
                    <div className="input-group-icon">
                      <i className="bx bx-search" />
                      <Input name="searchTerm" type="text" placeholder="ค้นหาราการโปรโมชัน" onChange={(e) => setSearchInput(e.target.value)} value={searchInput} invalid={formik.touched.searchTerm && formik.errors.searchTerm} data-testid="search-input" />
                      {formik.touched.searchTerm && formik.errors.searchTerm && (
                        <div className="error-message" data-testid="search-error">
                          {formik.errors.searchTerm}
                        </div>
                      )}
                    </div>
                  </div>
                  <Link to={`/contents/form`}>
                    <Button color="success" size="xs" onClick={() => {}} className="d-flex gap-2" data-testid="create-button">
                      <i className="bx bx-plus"></i>
                      เพิ่มบทความหรือโปรโมชัน
                    </Button>
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <ContentsTable data={contents} error={error} isLoading={isLoading} onStatusChange={handleStatusChange} onTableChange={handleTableChange} />
      </div>
    </Form>
  );
};

export default ContentsTab;
